<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
              v-model="item.name"
              :error-messages="nameErrors"
              :label="$t('global.name')"
              required
              @input="$v.item.name.$touch()"
              @blur="$v.item.name.$touch()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-row align="center">
            <v-col md="8" >
              <strong class="ml-4" >{{ $t('order.end') }}:</strong>
            </v-col>
            <v-col md="4">
              <v-switch
                  v-model="item.end"
                  :error-messages="endErrors"
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-row align="center">
            <v-col md="8" >
              <strong class="ml-4" >{{ $t('order.cancel') }}:</strong>
            </v-col>
            <v-col md="4">
              <v-switch
                  v-model="item.cancel"
                  :error-messages="cancelErrors"
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-row align="center">
            <v-col md="8" >
              <strong class="ml-4" >{{ $t('order.init') }}:</strong>
            </v-col>
            <v-col md="4">
              <v-switch
                  v-model="item.init"
                  :error-messages="initErrors"
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <h2>{{$t('order.couleur_departement')}}</h2>
        </v-col>
      </v-row>
      <v-row>
        
        <v-col cols="12" sm="6" md="6">
          <v-row align="center">
            <v-col md="8" >
              <strong class="ml-4" >{{ $t('order.stateColor') }}:</strong>
            </v-col>
            <v-col md="4">
              <v-text-field
                  v-model="item.couleur"
                  :error-messages="CouleurErrors"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-row align="center">
            <v-col md="8" >
              <strong class="ml-4" >{{ $t('order.enAttenteLabo') }}:</strong>
            </v-col>
            <v-col md="4">
              <v-switch
                  v-model="item.labo"
                  :error-messages="laboErrors"
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>

      </v-row>
      <v-row>

        <v-col cols="12" sm="6" md="6">
          <v-row align="center">
            <v-col md="8" >            
            </v-col>
            <v-col md="4">
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-row align="center">
            <v-col md="8" >
              <strong class="ml-4" >{{ $t('order.enAttenteCommerciaux') }}:</strong>
            </v-col>
            <v-col md="4">
              <v-switch
                  v-model="item.commerciaux"
                  :error-messages="commerciauxErrors"
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <h2>
            {{$t('order.specialstatus')}}
          </h2>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-row align="center">
            <v-col md="8" >
              <strong class="ml-4" >{{ $t('order.specialOrdered') }}:</strong>
            </v-col>
            <v-col md="4">
              <v-switch
                  v-model="item.specialOrdered"
                  :error-messages="specialOrderedErrors"
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-row align="center">
            <v-col md="8" >
              <strong class="ml-4" >{{ $t('order.specialToPrint') }}:</strong>
            </v-col>
            <v-col md="4">
              <v-switch
                  v-model="item.specialToPrint"
                  :error-messages="specialToPrintErrors"
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>

      </v-row>

      <v-row>

        <v-col cols="12" sm="6" md="6">
          <v-row align="center">
            <v-col md="8" >
              <strong class="ml-4" >{{ $t('order.specialDoable') }}:</strong>
            </v-col>
            <v-col md="4">
              <v-switch
                  v-model="item.specialDoable"
                  :error-messages="specialDoableErrors"
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-row align="center">
            <v-col md="8" >
              <strong class="ml-4" >{{ $t('order.specialPrinted') }}:</strong>
            </v-col>
            <v-col md="4">
              <v-switch
                  v-model="item.specialPrinted"
                  :error-messages="specialPrintedErrors"
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

    </v-container>
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'OrderStateForm',
  mixins: [validationMixin],
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
  },
  data() {
    return {
      name: null,
      end: null,
      cancel: null,
      init: null,
      labo:null,
      commerciaux:null,
      specialPrinted: null,
    };
  },
  computed: {

    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },

    nameErrors() {
      const errors = [];

      if (!this.$v.item.name.$dirty) return errors;

      has(this.violations, 'name') && errors.push(this.violations.name);

      !this.$v.item.name.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    endErrors() {
      const errors = [];
      if (!this.$v.item.end.$dirty) return errors;
      has(this.violations, 'end') && errors.push(this.violations.end);
      return errors;
    },
    cancelErrors() {
      const errors = [];
      if (!this.$v.item.cancel.$dirty) return errors;
      has(this.violations, 'cancel') && errors.push(this.violations.cancel);
      return errors;
    },    
    
    initErrors() {
      const errors = [];
      if (!this.$v.item.init.$dirty) return errors;
      has(this.violations, 'init') && errors.push(this.violations.init);
      return errors;
    },

    CouleurErrors() {
      const errors = [];
      if (!this.$v.item.couleur.$dirty) return errors;
      has(this.violations, 'couleur') && errors.push(this.violations.couleur);
      return errors;
    },

    LaboErrors() {
      const errors = [];
      if (!this.$v.item.labo.$dirty) return errors;
      has(this.violations, 'labo') && errors.push(this.violations.labo);
      return errors;
    },

    CommerciauxErrors() {
      const errors = [];
      if (!this.$v.item.commerciaux.$dirty) return errors;
      has(this.violations, 'commerciaux') && errors.push(this.violations.commerciaux);
      return errors;
    },


    specialToPrintErrors() {
      const errors = [];
      if (!this.$v.item.specialToPrint.$dirty) return errors;
      has(this.violations, 'specialToPrint') && errors.push(this.violations.specialToPrint);
      return errors;
    },
    specialOrderedErrors() {
      const errors = [];
      if (!this.$v.item.specialOrdered.$dirty) return errors;
      has(this.violations, 'specialOrdered') && errors.push(this.violations.specialOrdered);
      return errors;
    },
    specialDoableErrors() {
      const errors = [];
      if (!this.$v.item.specialDoable.$dirty) return errors;
      has(this.violations, 'specialDoable') && errors.push(this.violations.specialDoable);
      return errors;
    },
    specialPrintedErrors() {
      const errors = [];
      if (!this.$v.item.specialPrinted.$dirty) return errors;
      has(this.violations, 'specialPrinted') && errors.push(this.violations.specialPrinted);
      return errors;
    },
    

    violations() {
      return this.errors || {};
    }
  },
  methods: {
  },
  validations: {
    item: {
      name: {
        required,
      },
      end: {
      },
      cancel: {
      },
      init: {
      },
      couleur:{
      },
      labo:{
      },
      commerciaux:{
      },
      specialDoable: {},
      specialToPrint: {},
      specialOrdered: {},
      specialPrinted: {},
    }
  }
};
</script>
